module.exports = __webpack_public_path__ + "static/media/HindVadodara-Light.1477457c.eot";